export default "__VITE_ASSET__DG$UtxrZ__"